import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ModalImage from "react-modal-image";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetCivilAccountState, getCivilAccount } from "../../../store/civilAccount/action";
import { resetPaymentMethodState, getPaymentMethod } from "../../../store/paymentMethod/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";
import { resetSalesPaymentState, getSalesPayment as onGetSalesPayments, addNewSalesPayment as onAddNewSalesPayment, updateSalesPayment as onUpdateSalesPayment, deleteSalesPayment as onDeleteSalesPayment, getSalesPaymentLoading, resetSalesPaymentCreateState } from "../../../store/salesPayment/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import logoDark from "../../../assets/images/logo-dark.png";
import logoLight from "../../../assets/images/logo-light.png";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import defaultImg from "../../../assets/images/upload.png";
import PrintDoc from "./PrintDoc";
import ExportDoc from "../../../Components/Common/ExportDoc";

const SalesPayment = () => {
  const [pageIdx, setPageIdx] = useState(0)
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalAccPayment, setModalAccPayment] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [submitType, setSubmitType] = useState(null);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, salesPayments, salesPaymentAdded, isSalesPaymentCreated, isSalesPaymentSuccess, loading, error, paymentMethods, paymentMethodLoading, companies, companyLoading, departments, departmentLoading, civilAccounts, civilAccountLoading, branches, branchLoading, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    salesPaymentAdded: state.SalesPayment.salesPaymentAdded,
    salesPayments: state.SalesPayment.salesPayments,
    isSalesPaymentCreated: state.SalesPayment.isSalesPaymentCreated,
    isSalesPaymentSuccess: state.SalesPayment.isSalesPaymentSuccess,
    loading: state.SalesPayment.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    paymentMethods: state.PaymentMethod.paymentMethods,
    paymentMethodLoading: state.PaymentMethod.loading,
    shipmentMethods: state.ShipmentMethod.shipmentMethods,
    shipmentMethodLoading: state.ShipmentMethod.loading,
    departments: state.Department.departments,
    departmentLoading: state.Department.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.SalesPayment.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [salesPaymentList, setSalesPaymentList] = useState([]);
  const [salesPaymentDoc, setSalesPaymentDoc] = useState([]);
  const [salesPayment, setSalesPayment] = useState([]);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [civilAccountList, setCivilAccountList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [accountingList, setAccountingList] = useState([]);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSalesPayments = salesPayments;
      if (type !== "all") {
        //filteredSalesPayments = salesPayments.filter((salesPayment) => salesPayment.sales_payment_status.name === type);
      }
      setSalesPaymentList(filteredSalesPayments);
    }
  };

  useEffect(() => {
    setSalesPaymentList(salesPayments);
  }, [salesPayments]);

  useEffect(() => {
    if (companySelected) {
      dispatch(resetSalesPaymentState());
      dispatch(onGetSalesPayments({ companyId: companySelected.value }));
      handleGetDepartement(companySelected.value);
      handleGetCivilAccount(companySelected.value);
      handleGetPaymentMethod(companySelected.value, branchSelected.value);
      handleGetAccAccount(companySelected.value);
    }
  }, [companySelected]);

  const handleGetPaymentMethod = (id, branchId) => {
    dispatch(resetPaymentMethodState());
    dispatch(getPaymentMethod({ companyId: id, status: 2, branchId: branchId, type: "SalesPayment" }));
  };

  const handleGetDepartement = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  }

  const handleGetCivilAccount = (companyId) => {
    dispatch(resetCivilAccountState());
    dispatch(getCivilAccount({ companyId: companyId }));
  }

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    setSalesPayment(salesPaymentAdded);
  }, [salesPaymentAdded]);

  useEffect(() => {
    if (!isEmpty(salesPayments)) {
      setSalesPaymentList(salesPayments.map((el) => ({ ...el, isChecked: false })));
      setInfo(salesPayments[salesPayments.length - 1]);
    }
  }, [salesPayments]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "sales_payment_sales",
        label: "No Transaksi",
        isSelected: true,
        data: []
      },
      {
        id: "createdat",
        label: "Tanggal",
        isSelected: true,
        data: []
      },
      {
        id: "amount",
        label: "Fee Penjualan",
        isSelected: true,
        data: []
      },
      {
        id: "sales_payment_sales_agent",
        label: "Salesman",
        isSelected: true,
        data: []
      },
      {
        id: "sales_payment_sales_customer",
        label: "Konsumen",
        isSelected: true,
        data: []
      },
      {
        id: "at_status",
        label: "Status",
        isSelected: true,
        data: []
      },
      {
        id: "sales_payment_client",
        label: "Grup Usaha",
        isSelected: true,
        data: []
      },
      {
        id: "sales_payment_company",
        label: "Perusahaan",
        isSelected: true,
        data: []
      },
      {
        id: "sales_payment_branch",
        label: "Cabang",
        isSelected: true,
        data: []
      },
    ];

    if (salesPaymentList.length > 0) {
      salesPaymentList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find(d => d.id === key);

            if (doc) {
              if (doc.id === "sales_payment_sales") {
                const agentDoc = dataDoc.find(d => d.id === "sales_payment_sales_agent");
                const customerDoc = dataDoc.find(d => d.id === "sales_payment_sales_customer");


                agentDoc.data.push(value.sales_agent.name);
                customerDoc.data.push(value.sales_customer.name);
                doc.data.push(value.transaction_no);
              } else if (doc.id === "createdat") {
                doc.data.push(handleValidDate(value));
              } else if (doc.id === "amount") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else if (doc.id === "sales_payment_client" || doc.id === "sales_payment_company" || doc.id === "sales_payment_branch") {
                doc.data.push(value?.name ?? "-");
              } else {
                doc.data.push(value);
              }
            } else {
              if (key === "type") {
                const statusDoc = dataDoc.find(d => d.id === "at_status");
                let stat;
                let statName = data.type
                switch (statName) {
                  case "BOOKING":
                    stat = data.type;
                    break;
                  case "AKAD":
                    stat = data.type;
                    break;
                  default:
                    stat = statName;
                    break;
                }

                let type;
                switch (data.hasPaid) {
                  case false:
                    type = "UNPAID";
                    break;
                  case true:
                    type = "PAID";
                    break;
                  default:
                    type = data.type;
                    break;
                }
                statusDoc.data.push(`${stat} - ${type}`);
              }

            }
          });
        }
      });
    }

    setSalesPaymentDoc(dataDoc);
  }, [salesPaymentList])

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => { }, []);

  const handleBeforePrint = useCallback(() => { }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(paymentMethods)) {
      var data = [];
      var opt = [];
      paymentMethods.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setPaymentMethodList(data);
    }
    else {
      setPaymentMethodList([]);
    }
  }, [paymentMethods]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var departmentData = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      departmentData.push(option);
      setDepartmentList(departmentData);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(civilAccounts)) {
      var civilAccountData = [];
      var opt = [];
      civilAccounts.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      civilAccountData.push(option);
      setCivilAccountList(civilAccountData);
    }
  }, [civilAccounts]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSalesPayment(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setSalesPayment(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const toggleAccPayment = useCallback(() => {
    if (modalAccPayment) {
      setModalAccPayment(false);
    } else {
      setModalAccPayment(true);
    }
  }, [modalAccPayment]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const checkedAll = () => {
    const allChecked = salesPaymentList.every(item => item.isChecked);
    const updatedData = salesPaymentList.map(item => ({
      ...item,
      isChecked: !allChecked
    }));

    setSalesPaymentList(updatedData);
  };

  const columns = useMemo(() => [{
    id: "#",
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={salesPaymentList.every(item => item.isChecked)} onChange={checkedAll} />,
    filterable: false,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <div className="hstack gap-2">
          <input type="checkbox" className="dataCheckbox me-2 form-check-input" checked={data.isChecked} onChange={() => {
            const updatedData = salesPaymentList.map(d =>
              d.id === data.id ? { ...d, isChecked: !d.isChecked } : d
            );
            setSalesPaymentList(updatedData);
          }} />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button color="light" className="btn-sm" onClick={() => {
                setInfo(data.sales_payment_sales);
                toggle();
              }}><i className="ri-eye-line fs-15"></i></Button>
            </UncontrolledButtonDropdown>
          </ButtonGroup>
          {!data.hasPaid && (
            <button
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-sm btn-soft-success me-2" : userRole && userRole.split(",").indexOf("createAccTransaction") !== -1 ? "btn btn-sm btn-soft-success  me-2" : "d-none"} onClick={() => {
                setInfo(data);
                toggleAccPayment();
              }}><i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>PEMBAYARAN</button>
          )}
        </div>
      );
    },
  },
  {
    Header: "No Transaksi",
    accessor: "transaction_no",
    filterable: true,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      return (
        <Link
          to="#"
          className="fw-semibold text-dark"
          onClick={() => {
            setInfo(data.sales_payment_sales);
            toggle();
          }}>{data.sales_payment_sales && data.sales_payment_sales.transaction_no}</Link>
      )
    }
  },
  {
    Header: "Tanggal",
    accessor: "createdat",
    filterable: false,
    Cell: (data) => {
      return handleValidDate(data.row.original.createdat);
    },
  },

  {
    Header: "Fee Penjualan",
    accessor: "amount",
    filterable: true,
    Cell: (data) => {
      return <span className="fw-semibold">{currencyFormat(data.row.original.amount === null ? 0 : data.row.original.amount)}</span>;
    },
  },
  {
    Header: "Salesman",
    accessor: "sales_payment_sales.sales_agent.name",
    filterable: false,
  },

  {
    Header: "Konsumen",
    accessor: "sales_payment_sales.sales_customer.name",
    filterable: false,
  },
  {
    Header: "Status",
    accessor: "at_status.name",
    filterable: true,
    Cell: (data) => {
      let stat;
      let statName = data.row.original.type
      switch (statName) {
        case "BOOKING":
          stat = <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>{data.row.original.type}</span>;
          break;
        case "AKAD":
          stat = <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>{data.row.original.type}</span>;
          break;
        default:
          stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
          break;
      }

      let type;
      switch (data.row.original.hasPaid) {
        case false:
          type = <span className="badge text-uppercase badge-soft-warning">UNPAID</span>;
          break;
        case true:
          type = <span className="badge text-uppercase badge-soft-success">PAID</span>;
          break;

        default:
          type = <span className="badge text-uppercase badge-soft-primary">{data.row.original.type}</span>;
          break;
      }
      return (
        <div className="hstack gap-2">
          {stat}
          {type}
        </div>
      )
    }
  }], [salesPaymentList, toggle, toggleAccPayment, userType, userRole]);

  const {
    getTableProps, rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: salesPaymentList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Status"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,

      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page)
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  const validationAccPayment = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: (info && info.amount) || 0,
      account: "",
      transactionat: moment().format('YYYY/MM/DD'),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      account: Yup.object().required("Please enter payment account").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getSalesPaymentLoading());
      if (info) {
        info.setAccPayment = true;
        info.setApprove = false;
        info.accPaymentId = values.account.value;
        info.transactionat = values.transactionat;
        info.accType = "CASH OUT";
        info.description = `Pembayaran Fee (${info.type} ${info.sales_payment_sales && info.sales_payment_sales.sales_agent && info.sales_payment_sales.sales_agent.name} #${info.sales_payment_sales.code})`;
        info.amount = values.amount;
        dispatch(onUpdateSalesPayment(info));
      }
      validationAccPayment.resetForm();
      toggleAccPayment();
    },
  });

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "requested",
    };
    dispatch(onGetSalesPayments(param));
  }
  document.title = "Pencairan Fee Penjualan | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesPaymentList} />
      <Container fluid>
        <BreadCrumb title="Pencairan Fee Penjualan" pageTitle="Keuangan" />
        <Row>
          <Col xxl={12}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Data Pencairan Fee Penjualan &nbsp;
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>Loading...</Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                  <div className="flex-shrink-0">
                    <ExportDoc data={salesPaymentDoc} />
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"><i className="ri-bank-card-2-line me-1 align-bottom fs-15"></i> SEMUA TRANSAKSI
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""} /><i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="search-box me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Pilih Tanggal"
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }} /><i className="bx bx-calendar-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div>
                            <button
                              type="button"
                              className="btn btn-light w-100"
                              onClick={() => {
                                handleFilter();
                              }}><i className="ri-search-line me-1 align-bottom fs-14"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={() => {
                          setPageIdx(pageIndex - 1)
                          previousPage()
                        }} disabled={!canPreviousPage}>{"<"}</Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">Halaman {pageIndex + 1} dari {pageOptions.length}</Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={() => {
                          setPageIdx(pageIndex + 1)
                          nextPage()
                        }} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>DETAIL PENJUALAN</ModalHeader>
                  <ModalBody>
                    <CardBody className="pt-4 ps-4 pe-4">
                      <Row>
                        <Col lg={5} className="ms-auto">
                          <div className="row">
                            <div className="mb-1 fs-14 fw-semibold">
                              {info.sales_client && info.sales_client.name}
                            </div>
                            <div className="mb-3 fs-14 fw-semibold">{info.sales_company && info.sales_company.name}</div>
                            <div className="mb-1 fs-14">{info.sales_branch && info.sales_branch.name}</div>
                            <div className="mb-3 fs-14">PENJUALAN {info.sales_type && info.sales_type.name} {info.tenor ? ", Tenor " + info.tenor + " Bulan" : ""}</div>
                          </div>
                        </Col>
                        <Col lg={3}></Col>
                        <Col lg={4} className="ms-auto">
                          <div className="mb-2 fs-14 fw-semibold">No Penjualan : {info.transaction_no && info.transaction_no}</div>
                          <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {info.sls_bb && info.sls_bb.name}</div>
                          <div className="mb-2 fs-14 fw-semibold">{info.sales_customer && info.sales_customer.name}</div>
                          <div className="mb-2 fs-14 fw-semibold"><span className="badge text-uppercase badge-soft-info fs-12">{info.sales_agent && info.sales_agent.name}</span></div>
                        </Col>
                      </Row>
                    </CardBody>
                    <CardBody className="pt-4 ps-4 pe-4 border-top">
                      <h4 className="mb-3">Pemilihan Unit</h4>
                      <div>
                        <Table className="invoice-table table-borderless table-nowrap mb-0">
                          <thead className="align-middle">
                            <tr className="table-active">
                              <td style={{ width: "20px" }}>#</td>
                              <td>Unit Yang Dipilih</td>
                              {/* <td className="text-center" style={{ width: "150px" }}>{"Status Pemilihan"}</td> */}
                              <td className="text-center" style={{ width: "170px" }}>Harga Jual</td>
                              <td className="text-center" style={{ width: "170px" }}>Uang Muka</td>
                              <td className="text-center" style={{ width: "150px" }}>Administrasi</td>
                              <td className="text-center" style={{ width: "170px" }}>{"> Tanah"}</td>
                              <td className="text-center" style={{ width: "170px" }}>{"Total Kelebihan Tanah"}</td>
                            </tr>
                          </thead>
                          <tbody id="newlink">
                            {info.sales_detail && info.sales_detail.length > 0 && ((info.sales_detail.sort((a, b) => a.transaction_no - b.transaction_no)) || []).map((o, i) => {
                              return (
                                <tr key={i} id={i} className="product">
                                  <td className="product-id">
                                    {i + 1}
                                  </td>
                                  <td className="text-start">{o.name}</td>
                                  <td className="text-center fs-14">{currencyFormat(o.amount)}</td>
                                  <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat((parseFloat(o.amount) * (1 / 100)) || 0)}</td>
                                  <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat(o.price_handling)}</td>
                                  <td className="text-center fs-14">{parseInt(o.land_excess) || 0} M<sup>2</sup> <span className="fs-12">({currencyFormat(o.land_price || 0)})</span></td>
                                  <td className="text-center fs-14 text-danger fw-semibold">{currencyFormat((parseFloat(o.land_price) * parseFloat(o.land_excess)) || 0)}</td>
                                </tr>
                              );
                            })}
                            <tbody>
                            </tbody>
                            {info.sales_detail && info.sales_detail.length === 0 && (
                              <tr>
                                <td colSpan="7" className="p-3 text-center fs-14">Unit belum ditambahkan</td>
                              </tr>
                            )}
                          </tbody>
                        </Table>
                        <h4 className="mb-3 mt-3 pt-3 border-top">History Pembayaran</h4>
                        <div className="pt-3 ps-3 pe-3">
                          <div className="table-responsive mb-3 table-card">
                            <Table className="invoice-table table-borderless table-nowrap mb-0">
                              <thead className="align-middle">
                                <tr className="table-active">
                                  <td style={{ width: "20px" }}>#</td>
                                  <td>No Transaksi</td>
                                  <td>Tanggal Transaksi</td>
                                  <td>Keterangan</td>
                                  <td className="text-end" style={{ width: "170px" }}>Jumlah</td>
                                </tr>
                              </thead>
                              <tbody>
                                {((info.sales_trans) || []).map((o, i) => {
                                  return (
                                    <tr key={i}>
                                      <td className="product-id">{i + 1}</td>
                                      <td>{o.transaction_no}</td>
                                      <td>{handleValidDate(o.transactionat)}</td>
                                      <td>{o.description}</td>
                                      <td className="text-end" style={{ width: "170px" }}>{currencyFormat(o.amount)}</td>
                                    </tr>)
                                })}
                                <tbody>
                                </tbody>
                                {info.sales_trans && info.sales_trans.length === 0 && (
                                  <tr>
                                    <td colSpan="3" className="p-3 text-center fs-14">
                                      Belum ada transaksi Penerimaan
                                    </td>
                                  </tr>)}
                              </tbody>
                            </Table>
                          </div>
                        </div>
                        {info.credit_amount && info.credit_amount > 0 && (
                          <div className="row border-top">
                            <div className="col-lg-5 mt-3">
                              <div className="mb-3">
                                <label className="text-muted">Maksimum KPR : </label>
                                <div className="fw-semibold fs-16">
                                  {currencyFormat(((parseFloat(info.sub_amount) - ((parseFloat(info.sub_amount ?? 0) * (1 / 100)) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0)))) || 0)}
                                </div>
                              </div>
                              <div className="mb-3">
                                <label className="text-muted">ACC KPR : </label>
                                <div className={currencyFormat(info.credit_amount) ? "fw-semibold text-success fs-16" : "fw-semibold fs-16"}>
                                  {currencyFormat(info.credit_amount)}
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-1 col-lg-12"><label>Tanggal SP3K</label> {handleValidDate(info.bankat)} (Tenor {info.tenor})</div>
                              </div>
                              <div className="mb-1"><label>Status : </label> <span className="fw-semibold fs-14">{info.sales_bank_status && info.sales_bank_status.name}</span></div>
                              <div className="mb-3"><label>Keterangan Bank : </label> {info.description_bank ? info.description_bank : "-"}</div>
                            </div>
                            <div className="col-lg-3"></div>
                            <div className="col-lg-4 mt-3">
                              <div className="mb-3">
                                <label className="text-muted">Penurunan KPR : </label>
                                <div className="fw-semibold fs-16 text-danger">
                                  {currencyFormat(((parseFloat(info.sub_amount) - ((parseFloat(info.sub_amount) * (1 / 100)) + parseFloat(info.typeId === 1 ? info.sales_branch?.sbum : 0))) - info.credit_amount) || 0)}
                                </div>
                              </div>
                              <div className="mb-3">
                                <label className="text-muted">TOTAL HARUS BAYAR : </label>
                                <div className="fw-semibold text-danger fs-16">
                                  {currencyFormat(info.total_amount)}
                                </div>
                              </div>
                            </div>
                          </div>
                        )}

                        {info.completedat && (
                          <div className="pt-4 border-top">
                            <h4 className="mb-3">Jadwal Akad</h4>
                            <div className="row">
                              <div className="mb-3 col-lg-4"><label>Tanggal Akad : </label> <span className="fw-semibold text-success fs-16">{info.completedat && handleValidDate(info.completedat)}</span></div>
                            </div>
                          </div>
                        )}
                        <div className="pt-4 border-top">
                          <h4 className="mb-3">Bukti Transaksi</h4>
                          <div className="mb-3">

                            {info.sales_file && info.sales_file.length > 0 && info.sales_file.map((f, i) => {
                              if (f.isDeleted) {
                                return null;
                              } else {
                                return (<div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      {f.mimetype === "image/jpg" || f.mimetype === "image/png" || f.mimetype === "image/jpeg" ?
                                        <ModalImage showRotate={true}
                                          small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`}
                                          large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`}
                                          alt={info.name}
                                          className="img-thumbnail avatar-md img-thumbnail user-profile-image" />
                                        :
                                        <Link
                                          to={`${api.MEDIA_URL}/media/${f.filename}`}
                                          target="_blank"
                                          className={"img-thumbnail avatar-md img-thumbnail user-profile-image"}>
                                          <i className="ri-file-pdf-line fs-3 text-danger"></i>
                                        </Link>
                                      }
                                    </div>

                                    <div className="text-truncate">{f.originalname}</div>
                                  </div>
                                </div>);
                              }
                            })}
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </ModalBody>
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light" onClick={() => {
                          setModal(false);
                        }}>TUTUP</button>
                    </div>
                  </div>
                </Modal>
                <Modal id="showModalAccPayment" isOpen={modalAccPayment} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggleAccPayment}>
                    Pembayaran Fee Penjualan
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validationAccPayment.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label" > Jumlah</Label>
                          <Input
                            name="amount"
                            id="amount-field"
                            className="form-control"
                            placeholder="Enter amount"
                            type="number"
                            onFocus={e => e.target.select()}
                            onChange={validationAccPayment.handleChange}
                            onBlur={validationAccPayment.handleBlur}
                            value={validationAccPayment.values.amount || info.amount}
                            invalid={validationAccPayment.touched.amount && validationAccPayment.errors.amount ? true : false} />
                          {validationAccPayment.touched.amount &&
                            validationAccPayment.errors.amount ? (
                            <FormFeedback type="invalid">
                              {validationAccPayment.errors.amount}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount-field" className="form-label"> Tanggal Pembayaran</Label>
                          <Flatpickr
                            className="form-control"
                            id="datepicker-publish-input"
                            placeholder="Select transaction date"
                            options={{
                              mode: "single",
                              dateFormat: "Y/m/d",
                            }}
                            onChange={(selectedDates, dateStr) => {
                              validationAccPayment.setFieldValue("transactionat", dateStr);
                            }}
                            value={validationAccPayment.values.transactionat ?? ""} />
                        </div>
                        <div className="mb-3 col-lg-12">
                          <label className="form-label" htmlFor="account">Akun Cash / Bank Pembayaran</label>
                          <Select
                            name="account"
                            value={validationAccPayment.values.account}
                            placeholder="Enter account"
                            onChange={(e) => {
                              validationAccPayment.setFieldValue("account", e);
                            }}
                            options={accountingList}></Select>
                          {validationAccPayment.touched.account && validationAccPayment.errors.account && (
                            <small className="text-danger" type="invalid">
                              {validationAccPayment.errors.account}
                            </small>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModalAccPayment(false);
                            validationAccPayment.resetForm();
                          }}>Tutup</button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">SIMPAN PEMBAYARAN</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
                <Modal id="showModalDetail" isOpen={modalDetail} centered size="lg">
                  <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
                    Invoice Detail
                  </ModalHeader>
                  {salesPayment !== undefined && salesPayment !== null ? (
                    <ModalBody>
                      <Row id="printThis">
                        <Col lg={12}>
                          <CardHeader className="border-bottom-dashed p-4">
                            <div className="d-flex">
                              <div className="flex-grow-1">
                                <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                                <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" />
                                <div className="mt-sm-3 mt-3">
                                  <h6 className="text-uppercase fw-semibold">{salesPayment.client && salesPayment.client.label}</h6>
                                  <p className="mb-1">{salesPayment.company && salesPayment.company.label}</p>
                                </div>
                              </div>
                            </div>
                          </CardHeader>
                          <CardBody className="p-4">
                            <Row className="g-3">
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Invoice No</p>
                                <h5 className="fs-14 mb-0">
                                  #<span id="invoice-no">{salesPayment.transaction_no}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(salesPayment.transactionat)}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Due Date</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="invoice-date">{handleValidDate(salesPayment.dueat)}</span>
                                </h5>
                              </Col>
                              <Col lg={3} xs={3}>
                                <p className="text-muted mb-2 text-uppercase fw-semibold">Total</p>
                                <h5 className="fs-14 mb-0">
                                  <span id="total-amount">{currencyFormat(salesPayment.total_amount)}</span>
                                </h5>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardBody className="p-4">
                            <div>
                              <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                                <thead>
                                  <tr className="table-active">
                                    <th scope="col" style={{ width: "50px" }}>
                                      #
                                    </th>
                                    <th scope="col">Detail Produk</th>
                                    <th scope="col">Rate</th>
                                    <th scope="col">Quantity</th>
                                    <th scope="col">Accepted</th>
                                    <th scope="col">Rejected</th>
                                    <th scope="col" className="text-end">
                                      Amount
                                    </th>
                                  </tr>
                                </thead>
                                <tbody id="products-list">
                                  {(salesPayment.items || []).map((o, i) => {
                                    return (
                                      <tr key={i} id={i} className="product">
                                        <th scope="row" className="product-id">{i + 1}</th>
                                        <td className="text-start">{o.label}</td>
                                        <td>{currencyFormat(o.amount)}</td>
                                        <td>{o.quantity}</td>
                                        <td>{o.accepted}</td>
                                        <td>{o.rejected}</td>
                                        <td className="text-end">{currencyFormat(o.total)}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <div className="border-top border-top-dashed mt-2">
                              <Table className="table table-borderless table-nowrap align-middle mb-0 ms-auto" style={{ width: "250px" }}>
                                <tbody>
                                  <tr>
                                    <td>Sub Total</td>
                                    <td className="text-end">{currencyFormat(salesPayment.sub_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Diskon</td>
                                    <td className="text-end">{currencyFormat(salesPayment.disc_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Biaya Kirim</td>
                                    <td className="text-end">{currencyFormat(salesPayment.shipment_amount)}</td>
                                  </tr>
                                  <tr>
                                    <td>Pajak {salesPayment.tax_percentage} %</td>
                                    <td className="text-end">{currencyFormat(salesPayment.tax_amount)}</td>
                                  </tr>
                                  <tr className="border-top border-top-dashed fs-15">
                                    <th scope="row">Total Amount</th>
                                    <th className="text-end">{currencyFormat(salesPayment.total_amount)}</th>
                                  </tr>
                                </tbody>
                              </Table>
                            </div>
                            <div className="mt-4">
                              <div className="alert alert-info">
                                <p className="mb-0">
                                  <span className="fw-semibold">NOTES:</span>
                                  <span id="note"> {salesPayment.description}</span>
                                </p>
                              </div>
                            </div>
                            <div className="mt-4">
                              <div>
                                <p className="mb-0">{salesPayment.user}</p>
                              </div>
                            </div>
                          </CardBody>
                        </Col>
                      </Row>
                    </ModalBody>
                  ) : null}
                  <div className="modal-footer">
                    <div className="hstack gap-2 justify-content-end">
                      <button
                        type="button"
                        className="btn btn-light" onClick={() => {
                          toggleDetail();
                        }}>
                        Close</button>
                      <button
                        type="submit"
                        className="btn btn-info" onClick={() => {
                          handlePrint();
                        }}>
                        Print Document&nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
                      </button>
                    </div>
                  </div>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
        <PrintDoc innerRef={printRef} item={salesPayment} />
      </Container>
    </div >
  );
};

export default SalesPayment;
